import { render, staticRenderFns } from "./form-workspace-create.vue?vue&type=template&id=4e3c6d02&"
import script from "./form-workspace-create.vue?vue&type=script&lang=js&"
export * from "./form-workspace-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports